import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  webSimpleColumnEdit (params) {
    return axios.post(global.CMS_BASE + '/simpleColumn/updateWebSimpleColumn', params)
  },
  findWebSimpleColumn (params) {
    return axios.post(global.CMS_BASE + '/simpleColumn/findWebSimpleColumn', params)
  },
  updateRecruitJoinUs (params) {
    return axios.post(global.CMS_BASE + '/recruit/updateRecruit', params)
  },
  findRecruitJoinUs (params) {
    return axios.post(global.CMS_BASE + '/recruit/findRecruit', params)
  }

}



// WEBPACK FOOTER //
// ./src/request/cms/webSimpleColumn.js